export const maxRatio = 19.5 / 9; // iPhone x
export const minRatio = 4 / 3; // iPad

export const defaultWidth = 1920;
export const defaultHeight = 886;

export const maxLeft = 375;
